import React, { useEffect } from "react";

import ChatbotWorkspace from "../../components/SPanel/ChatbotWorkspace";

export default function APChatbot() {
   useEffect(() => {
      document.title = "Instruire Auto | Chatbot";
   }, []);

   return (
      <main className="main">
         <section className="page-wrapper chatbot-page">
            <ChatbotWorkspace />
         </section>
      </main>
   );
}
